export const en = {
  nav: {
    pronos: "Picks",
    standings: "Standings",
    shop: "Shop",
    profile: "Profile",
    league: "Play",
  },

  login: {
    chooseNickname: "Choose your nickname",
    playerNamePlaceholder: "Player name",
    playAsGuest: "Play as Guest",
    joiningGame: "Joining game…",
    or: "or",
    continueWithGoogle: "Continue with Google",
    continueWithEmail: "Continue with email",
    nicknameChosenAfterSignIn: "Nickname chosen after sign-in.",

    emailPlaceholder: "your@email.com",
    invalidEmail: "Enter a valid email.",
    sendFailed: "Failed to send. Try again.",
    sending: "Sending…",
    receiveCode: "Receive my code →",
    codeSentTo: (email: string) => `Code sent to ${email}`,
    enterCodePlaceholder: "Enter code",
    enterCodeFromEmail: "Enter the code from your email.",
    invalidCode: "Invalid or expired code. Try again.",
    verifying: "Verifying…",
    signIn: "Sign in →",
    back: "← Back",

    atLeast3Chars: "At least 3 characters.",
    max14Chars: "14 characters max.",
    invalidChars: "Letters, numbers, . _ and Korean only.",
  },

  nicknameSetup: {
    signedInChooseNickname: "Signed in! Choose your in-game nickname.",
    nicknameLabel: "Nickname",
    playerNamePlaceholder: "Player name",
    creating: "Creating your account...",
    startPlaying: "Start playing →",
  },

  recover: {
    title: "Welcome back!",
    foundAccount: (name: string) =>
      `We found the account “${name}” on this device. It is not connected to this Google account yet.`,
    connectButton: (name: string) => `This is my account — connect “${name}”`,
    connecting: "Connecting your account…",
    notMineButton: "Not mine — create a new account",
    restoreSession: "← Go back to my previous session",
  },

  pronos: {
    title: "WORLD CUP 2026",
    today: "Today",
    tomorrow: "Tomorrow",
    finishedCount: (n: number) => `✅ Finished (${n})`,
    noFinishedMatches: "No finished matches yet.",
    draw: "Draw",
    matchFinished: "Match finished",
    myPredictionLabel: "My pick",
    noBetPlaced: "No pick placed",
    liveBetsClosed: "Live — bets closed",
    betsClosed: "Bets closed",
  },

  classement: {
    title: "Standings",
    refresh: "Refresh",
    picksTab: "🎯 Picks Points",
    duelTab: "⚔️ Duel",
    stadiumTab: "🏟️ Stadium",
    globalTab: "🌍 Global",
    friendsTab: (n: number) => `👥 Friends (${n})`,
    noFriendsYet: "No friends yet, follow players from the Global tab!",
    makeFirstPredictions: "Make your first picks to enter the standings!",
    noFiveDuelPlayers: "No Duel rankings yet. Play to compete!",
    noStadiumPlayers: "No Stadium Trial climbers yet. Play to claim a tier!",
    tierBadge: "TIER",
    stageBest: (n: number) => `Best: Stage ${n}/10`,
    youBadge: "YOU",
    kLeagueTrophiesTooltip: "K League Trophies",
    max: "MAX",
    level: (n: number) => `Lv.${n}`,
    points: "POINTS",
    statistics: "Statistics",
    following: "✓ Following",
    follow: "+ Follow",
    close: "Close",
    winrate: "WINRATE",
    pronos: "PICKS",
    power: "POWER",
  },

  shop: {
    title: "Shop",
    balanceLabel: (n: number) => `Balance: ${n.toLocaleString("en-US")} coins`,

    standardBoxTitle: "Standard Item Box",
    standardBoxSubtitle: "One random equipment item, common to legendary",
    premiumBoxTitle: "Premium Item Box",
    premiumBoxSubtitle: "Better drop rates, guaranteed rare+",
    cosmeticBoxTitle: "Cosmetic Box",
    cosmeticBoxSubtitle: "One random cosmetic equipment set",

    openButton: "Open",

    freeAvailable: "🎁 Free opening available, tap to claim",
    nextFreeIn: (time: string) => `Next free box in ${time}`,
    freeAtLevel: (n: number) => `🎁 Free at level ${n}, tap to claim`,
    nextFreeAtLevel: (n: number) => `Next free box at level ${n}`,

    footerNote: "Earn coins by getting your picks right. The free box refreshes every day.",

    tapToOpen: "Tap to open",
    revealContinue: "Continue",

    adminTitle: "🛠 Admin, Drop Item",
    adminDropButton: "Add to inventory",
  },

  profil: {
    settingsTitle: "Account",
    guestAccount: "Guest account",
    linkedAccount: "Linked account",
    signOut: "Sign out",
    signOutConfirmTitle: "Sign out?",
    signOutConfirmSub: "As a guest, you will permanently lose all your progress.",
    signOutConfirmBtn: "Yes, sign out",
    cancel: "Cancel",

    saveModalTitle: "Save my progress",
    saveModalSubtitle: "Link your account so you never lose your data.",
    withGoogle: "With Google",
    continueWithEmail: "Continue with email",

    saveProgressTitle: "Save your progress",
    saveProgressSubtitle: "Link your account, never lose your data.",
    save: "Save",

    statPoints: "POINTS",
    statWinrate: "WINRATE",
    statPicks: "PICKS",
    statPower: "POWER",
    levelLabel: "LVL",

    equipmentTab: "⚔️ Equipment",
    statisticsTab: "📊 Statistics",

    inventoryTitle: "Inventory",
    autoEquip: "Auto-equip",
    allEquipped: "All items equipped, open a pack for more.",

    equipmentStatsTitle: "Equipment Stats",
    equipmentStatsSub: "based on equipped items",
    radarLabel: "Radar",
    injuryReduction: "Injury Reduction",
    statFromGear: "gear",
    statFromLevel: "level",

    recentPicksTitle: "Recent Picks",
    drawPick: "Draw",

    rankLegendaire: "LEGENDARY",
    rankElite: "ELITE",
    rankExpert: "EXPERT",
    rankPro: "PRO",
    rankRookie: "ROOKIE",

    sandboxLabel: "🧪 Sandbox, visible only to aseo.bonjour",
    testLevelUp: "⬆️ Level Up",
    testBetResult: "🎲 Pick Result",

    changeAvatarTooltip: "Change avatar",
  },

  betResult: {
    matchCount: (n: number) => `${n} ${n > 1 ? "matches" : "match"}`,
    resultsTitle: "Pick Results",
    continue: "Continue",

    vs: "vs",
    myPrediction: (score: string) => `My pick: ${score}`,

    yourRewards: "Your rewards",
    accept: "Accept",
  },

  levelUp: {
    levelUpLabel: "Level Up!",
    levelReached: (n: number) => `Lvl ${n}`,
    ticketEarned: "+1 Loge Ticket!",
    ticketDropNote: "Drop rate 10%, nice luck!",
    noTicketNote: "No ticket this time. Keep playing for a chance to earn one at each level up, 10% drop rate.",
    continueButton: "Continue",
  },

  itemModal: {
    sell: "Sell",
    sellConfirmTitle: "Sell this item?",
    sellConfirmSub: "This cannot be undone.",
    unequip: "Unequip",
    equip: "Equip",
    total: "Total",
    defense: "Defense",
    cancel: "Cancel",
    same: "Same",
  },

  items: {
    slots: {
      head: "Head",
      top: "Kit",
      shoes: "Shoes",
      ball: "Ball",
      background: "Background",
      familiar: "Companion",
    },

    stats: {
      technique: "Technique",
      defense: "Defense",
      physique: "Physical",
      vitesse: "Health",
      blessure: "Injury Reduction",
      energy: "Mana",
    },

    statsShort: {
      TEC: "TEC",
      DEF: "DEF",
      PHY: "PHY",
      VIT: "HP",
    },

    rarity: {
      commun: "Common",
      rare: "Rare",
      epic: "Epic",
      ultra: "Legendary",
    },

    sellFor: (n: number) => `Sell for ${n}`,
    emptySlot: "Empty",
    maxLevel: "MAX",
  },

  itemCard: {
    emptySlot: "Empty",
  },

  leagueJoin: {
    back: "← Back",
    createTeamTitle: "Create a team",
    createTeamSubtitle: "Your team will be visible to other players. Choose a memorable name.",
    teamNamePlaceholder: "Team name...",
    createAndJoin: "Create and join →",

    communityLeagueTitle: "Community League",
    communityLeagueDesc: "Join a team, combine your power, and face bot opponents. 1 match per day, promotion and relegation every week.",

    joinTeamHeader: "Join a team",
    createTeamButton: "+ Create a team",
    joinArrow: "Join →",
    teamMeta: (players: number, power: number) => `${players} players · ⚡ ${power} power`,
  },

  leagueHub: {
    fiveDuelSubtitle: "Ranked 1v1 duel — your build, your spells",
    comingSoon: "COMING SOON",
    teamLeagueSubtitle: "Climb leagues with your friends",
    stadiumTrialSubtitle: "Solo PVE · 10 stages · Auto-combat",
  },

  leagueRatings: {
    victory: "Victory!",
    draw: "Draw",
    defeat: "Defeat",
    mvpBadge: "MVP",
    meBadge: "ME",
    continue: "Continue",
  },

  leagueSettings: {
    title: "League Settings",
    currentTeamLabel: "Current team",
    leaveTeam: "Leave team",
    leaveConfirmMsg: "Are you sure? You'll go back to the team selection screen.",
    confirmLeave: "Yes, leave team",
    cancel: "Cancel",
    close: "Close",
  },

  leagueElo: {
    title: "League Tiers",
    subtitle: "Finish 1st in your group to climb a league each week.",
    currentBadge: "CURRENT",
    minElo: (n: number) => `${n}+ ELO`,
    close: "Close",
  },

  leagueOverview: {
    title: "League",
    prepareMatches: "Prepare Matches",
    preparedRatio: (done: number, total: number) => `${done}/${total}`,

    assetsOnField: "🃏 Assets on the field",
    leagueGolds: "💰",
    noAssetsYet: "No one has sent an asset to the field yet.",
    meBadge: "Me",

    standingsTab: "🏆 Standings",
    scheduleTab: "📅 Match Schedule",

    rankColumn: "#",
    teamColumn: "Team",
    playedColumn: "P",
    wdlColumn: "W-D-L",
    ptsColumn: "Pts",

    standingsTitle: (rank?: number) => rank != null ? `🏆 Standings · #${rank}` : "🏆 Standings",
    meBadgeInline: "ME",

    roundLabel: (n: number) => `Round ${n}`,
    fullTime: "Full time",
    matchesPlayed: "Matches played",
    vs: "VS",
    win: "Win",
    loss: "Loss",
    draw: "Draw",
    startsIn: (h: number, m: string) => `Starts in ${h}h ${m}m`,

    played: "Played",
    ready: "Ready",
    prepare: "Prepare",

    backToLeagueOverview: "← League Overview",

    communityLeagueLabel: "Community League",
    rosterLabel: "👥 Roster",
    botGkLevel: (n: number) => `Bot Goalkeeper — Level ${n}`,
    gkUpgradeHint: "Upgradeable in the Preparation tab",
    teamComposition: (p: number, b: number) => `${p} players · ${b} bots`,
    matchesPlayedCount: (n: number) => `${n} matches played`,
    winsPercent: (n: number) => `${n}% wins`,
  },

  leaguePrep: {
    shopLockedUntilTomorrow: "🔒 Locked until tomorrow",
    resetsIn: (time: string) => `Resets in ${time}`,
  },

  orbFusion: {
    back: "← Preparation",
    title: "Fuse Orbs",

    powerUnlocked: "Power unlocked",
    findItInPrep: "Find it in your preparation page.",
    nice: "Nice!",

    craft: "Craft",
    notEnoughResources: "Not enough resources",
    locked: "Locked",

    specialRecipesTitle: "Special Recipes",
    bettingPointsDisplay: (pts: number) => `🏆 ${pts.toLocaleString("en-US")} pts`,
    specialRecipesSubtitle: "Unlock them by earning sports pick points.",

    toUnlock: "· to unlock",
    levelUp: (n: number, effect: string) => `· Lv. ${n}: ${effect}`,
    ptsLabel: (pts: string) => `${pts} pts`,

    lockedLabel: (pts: string) => `🔒 ${pts} pts`,

    levelBadge: (n: number) => `Lv. ${n}`,

    effects: {
      precision: "+{pct}% precision",
      tackle_safety: "-{pct}% fouls",
      goalkeeper_buff: "+{pct}% to goalkeeper",
      counter_chance: "+{pct}% counterattack",
      build_up: "+{pct}% build-up",
      enemy_debuff: "-{pct}% opp. attack",
    },
  },

  matchResult: {
    win: "win",
    draw: "draw",
    loss: "loss",
  },

  matchSheet: {
    back: "← Back",
    title: "Match Sheet",
    sandboxMode: "🧪 Sandbox — test simulation",
    noSpell: "No spell",
    runTest: "▶ Run test match",
    runTestHint: "Run a match to see the engine output.",
    statsTitle: "Statistics",
    highlightsTitle: "Key Moments",
    debugTitle: "🧪 Engine Debug",
    debugLog: (n: number) => `Sequence Log (${n})`,
    debugCurve: "Power curve: 0.85 − 0.35×(def/att)^1.65 · clamp [15%–85%] · goalkeeper [42%–91%]",
    spellsTitle: "Spells Used",
    noSpellUsed: "No spell used for this match.",

    statPossession: "Possession",
    statShots: "Shots",
    statShotsOnTarget: "Shots on Target",
    statSaves: "Saves",
    statPasses: "Passes",
    statPassAccuracy: "Pass Accuracy",
    statInterceptions: "Interceptions",
    statDribbles: "Dribbles",
    statTackles: "Tackles",
    statCounters: "Counter-Attacks",

    outcomeGoal: "GOAL",
    outcomeShotSaved: "Goalkeeper Save",
    outcomeShotOff: "Off Target",
    outcomeTackle: "Tackle",
    outcomeInterception: "Interception",
    outcomeCounter: "→ Counter",
    outcomeBuildup: "Possession",

    controlLabel: "Control (possession)",
    inspectTitle: "Inspect 1v1 Duel",
    rawStats: "Raw Stats",
    dribVsTackle: "Dribble vs Tackle",
    shotVsBlock: "Shot vs Block",
    dribVsTackleCounter: "Dribble vs Tackle (counter)",
    shotVsBlockCounter: "Shot vs Block (counter)",
    gkFormula: (prob: string, keeper: string, finish: string, min: string, max: string) =>
      `${prob} (goalkeeper ${keeper} vs shot ${finish}, clamp ${min}–${max}%)`,
    homeSpell: (drib: string, fin: string, tackle: string) => `Home spell: ×${drib} dribble · ×${fin} shot · ×${tackle} tackle`,
    awaySpell: (drib: string, fin: string, tackle: string) => `Away spell: ×${drib} dribble · ×${fin} shot · ×${tackle} tackle`,

    win: "Victory",
    draw: "Draw",
    loss: "Defeat",

    savedText: "saved",
    goalText: "🚨 GOAL",

    statTechnique: "Technique",
    statDefense: "Defense",
    statPhysique: "Physical",
    statVitesse: "Health",
  },

  leagueDuel: {
    prepTitle: "Preparation",
    prepSubtitle: "You're the captain. Choose your formation and 3 spells.",
    energyLabel: (cur: number, max: number) => `⚡ ENERGY ${cur}/${max}`,
    energyFull: "Full",
    energyRegen: (time: string) => `+1 in ${time}`,
    compositionLabel: "FORMATION",
    spellsLabel: (cur: number, total: number) => `SPELLS (${cur}/${total})`,
    launchMatch: "Start match ⚽",
    noEnergy: "⚡ No energy",

    chestTitle: "DAILY CHEST",
    chestClaimed: "Already claimed. Come back tomorrow!",
    chestReady: "🎁 Chest ready — tap to open!",
    chestProgress: (cur: number, goal: number) => `${cur}/${goal} matches today`,

    goalsBar: "GOALS",
    finished: "Full time",
    phase: (cur: number, total: number) => `Phase ${cur} / ${total}`,
    eventsLabel: "EVENTS",
    skipButton: "Skip ⏭",
    eventGoal: "⚽ Goal!",
    eventSave: "🧤 Great save!",
    eventInterception: "🛡️ Interception!",
    eventShot: "🎯 Great shot!",

    resultWin: "Victory 🏆",
    resultLoss: "Defeat",
    resultDraw: "Draw",
    opponentElo: (elo: number) => `Opponent ${elo} ELO`,
    goalsTitle: "GOALS",
    noGoals: "No goals — solid defense.",
    goalEvent: (player: string, phase: number) => `⚽ ${player} — phase ${phase}`,
    replay: "Play again",
    exit: "Exit",

    formations: {
      "3-1": "More defensive",
      "2-2": "Balanced",
      "1-3": "More offensive",
    },

    spells: {
      boost: { name: "Sprint", desc: "Accelerates a player." },
      wall: { name: "Wall", desc: "Reinforces defense." },
      curve: { name: "Curve", desc: "Hard-to-stop shot." },
      freeze: { name: "Freeze", desc: "Slows the opponent." },
      heal: { name: "Second Wind", desc: "Reduces fatigue." },
      vision: { name: "Vision", desc: "Better passing." },
    },

    chestClaimedShort: "Claimed",
    prepScreenTitle: "Solo Duel",
    defensesButton: "🛡️ Defenses",
    defensesTitle: "Defenses",
    defensesSubtitle: "Ghost attacks on you",
    defensesLoading: "Loading…",
    defensesEmpty: "No attacks yet",
    defensesEmptyDesc: "Nobody has attacked your ghost defense yet.",
    defenseWon: "Defended",
    defenseLost: "Defeated",
    captainBadge: "Captain",
    energyNextIn: (time: string) => `Get 1 energy in ${time}`,
    squadTitle: "Your Squad",
    squadSubtitle: "These teammates are recruited and managed by you",
    formationTitle: "Formation",
    maxRank: "Max rank",
    findOpponent: "Find Opponent · 1⚡",
    findingOpponent: "🔍 Finding opponent…",
    creatingMatch: "⚽ Creating match…",
    timeJustNow: "just now",
    timeMinutesAgo: (m: number) => `${m}m ago`,
    timeHoursAgo: (h: number) => `${h}h ago`,
    timeDaysAgo: (d: number) => `${d}d ago`,
    reputation: "reputation",
    newRankLabel: (rank: string) => `🏅 New rank: ${rank}`,
    continueButton: "Continue",
    goldenGoal: "⚡ Golden Goal",
  },

  topBar: {},

  feedback: {
    title: "Send feedback",
    subtitle: "Found a bug or have an idea? Tell us — it goes straight to the team.",
    catBug: "Bug",
    catIdea: "Idea",
    catOther: "Other",
    placeholder: "What's on your mind?",
    send: "Send",
    sending: "Sending…",
    error: "Couldn't send — please try again.",
    thanksTitle: "Thanks for the feedback!",
    thanksSub: "It really helps improve the game.",
  },

  common: {
    live: "LIVE",
    draw: "Draw",
    vs: "vs",
    close: "Close",
    cancel: "Cancel",
    back: "← Back",
    continue: "Continue",
    loading: "Loading…",
    matchCount: (n: number) => `${n} match${n > 1 ? "es" : ""}`,
  },
} as const;

type WidenTranslations<T> = {
  readonly [K in keyof T]: T[K] extends (...args: infer A) => string
    ? (...args: A) => string
    : T[K] extends object
    ? WidenTranslations<T[K]>
    : string;
};

export type Strings = WidenTranslations<typeof en>;
